import { render, staticRenderFns } from "./health.vue?vue&type=template&id=9ce6b996&"
import script from "./health.vue?vue&type=script&lang=js&"
export * from "./health.vue?vue&type=script&lang=js&"
import style0 from "./health.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports